/* tslint:disable */
/* eslint-disable */
/**
 * cro-fiona-search
 * Fiona Search Service
 *
 * The version of the OpenAPI document: 0.2.171
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApprovabilityRequest,
    ApprovabilityResult,
} from '../models';

export interface ApprovabilityControllerApprovabilityRequest {
    approvabilityRequest?: ApprovabilityRequest;
}

/**
 * ApprovabilityControllerApi - interface
 * 
 * @export
 * @interface ApprovabilityControllerApiInterface
 */
export interface ApprovabilityControllerApiInterface {
    /**
     * 
     * @param {ApprovabilityRequest} [approvabilityRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApprovabilityControllerApiInterface
     */
    approvabilityControllerApprovabilityRaw(requestParameters: ApprovabilityControllerApprovabilityRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApprovabilityResult>>;

    /**
     */
    approvabilityControllerApprovability(requestParameters: ApprovabilityControllerApprovabilityRequest, initOverrides?: RequestInit): Promise<ApprovabilityResult>;

}

/**
 * 
 */
export class ApprovabilityControllerApi extends runtime.BaseAPI implements ApprovabilityControllerApiInterface {

    /**
     */
    async approvabilityControllerApprovabilityRaw(requestParameters: ApprovabilityControllerApprovabilityRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApprovabilityResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/calculators/approvability`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.approvabilityRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async approvabilityControllerApprovability(requestParameters: ApprovabilityControllerApprovabilityRequest = {}, initOverrides?: RequestInit): Promise<ApprovabilityResult> {
        const response = await this.approvabilityControllerApprovabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
